
import { useState, useEffect, Component } from 'react';
import { DataScroller } from 'primereact/datascroller';
import moment from 'moment';
import { getPromoTypeDescription, getValorePromo } from '../../utilities/promo.utilities';
import { useLocation } from 'react-router-dom';
import { getAllCustomerInfo } from '../../service/allCustomerInfo.service';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import React from 'react';
import { getPromoDays, goTo } from '../../utilities/common.utilities';
import { useConnectivity } from '../../context/connectivityContext';
import "./promo.css";

interface Promo {
  appPicture: string;
  appTemplate: string;
  daysAfterBirthday: number;
  description: string;
  endDate: string;
  friday: boolean;
  id: number;
  isBirthdayCampaign: boolean;
  monday: boolean;
  name: string;
  promoType: string;
  promotedCategories: any[];
  promotedCategoriesDetail: any[];
  promotedProducts: string[];
  promotedProductsDetail: { code: string; name: string }[];
  promotedSuppliers: any[];
  promotedSuppliersDetail: any[];
  rating: number;
  saturday: boolean;
  startDate: string;
  sunday: boolean;
  thursday: boolean;
  tuesday: boolean;
  validTo: string;
  value: number;
  wednesday: boolean;
  showDescription: boolean;
  contactValidFrom: string;
  contactValidTo: string;
}

// class PromoComponent extends Component {
//     // const [promo, setPromo] = useState<Promo[]>([]);
//     groupId = JSON.parse(localStorage.getItem("cards") || "").cards[0].groupId;
export default function PromoComponent() {
    const location = useLocation();

    // Se non sono presenti dati in location.state, reindirizzo in home al posto
    // di far andare in errore il componente
    if(!location.state) {
        goTo('/home');
    }

    const { cardData } = location.state;
    const [promo, setPromo] = useState<Promo[]>([]);

    // Variabile utilizzata per sapere se ci sono errori nella ricezione delle promozioni come l' assenza di connessione.
    // Utilizzata per distinguere sul template, se la mancanza di promo è dovuta ad errore oppure effettivamente non c'è ne sono.
    const [errorGetPromo, setErrorGetPromo] = useState<boolean>(false);
    const { isOnline } = useConnectivity();

    const getPromo = () => {
        //return JSON.parse(localStorage.getItem("allCustomerInfo") || "").loyalties.promos.map( (x:Promo) => {
            getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(allCustomerInfo => {
                let result: Promo[] = []; 
                setErrorGetPromo(false);

                    if(!allCustomerInfo) {
                        result = [];
                        setErrorGetPromo(true);
                    }
                    else if(allCustomerInfo?.loyalties?.promos?.length > 0){
                        allCustomerInfo.loyalties.promos.map((x: Promo) => {
                            result.push({
                                appPicture: x.appPicture ? x.appPicture.replace('/storage','') : '' ,
                                appTemplate: x.appTemplate ,
                                daysAfterBirthday: x.daysAfterBirthday ,
                                description: x.description ,
                                endDate: x.endDate ,
                                friday: x.friday ,
                                id: x.id ,
                                isBirthdayCampaign: x.isBirthdayCampaign ,
                                monday: x.monday ,
                                name: x.name ,
                                promoType: x.promoType ,
                                promotedCategories: x.promotedCategories ,
                                promotedCategoriesDetail: x.promotedCategoriesDetail ,
                                promotedProducts: x.promotedProducts ,
                                promotedProductsDetail: x.promotedProductsDetail ,
                                promotedSuppliers: x.promotedSuppliers ,
                                promotedSuppliersDetail: x.promotedSuppliersDetail ,
                                rating: x.rating ,
                                saturday: x.saturday ,
                                startDate: x.startDate ,
                                sunday: x.sunday ,
                                thursday: x.thursday ,
                                tuesday: x.tuesday ,
                                validTo: x.validTo ,
                                value: x.value ,
                                wednesday: x.wednesday,
                                showDescription: false ,
                                contactValidFrom: x.contactValidFrom,
                                contactValidTo: x.contactValidTo
                            });
                        })
                    } else {
                        result = [];
                    }
    
                    if(result.length > 0){
                        setPromo(result);
                      } else {
                        setPromo([]);
                    }

            });
            
        
    }

    const handleShowDescription = (id: number) => {
        const temp_promo = promo.map((x) => {
            if (x.id === id) {
                return {
                    appPicture: x.appPicture ,
                    appTemplate: x.appTemplate ,
                    daysAfterBirthday: x.daysAfterBirthday ,
                    description: x.description ,
                    endDate: x.endDate ,
                    friday: x.friday ,
                    id: x.id ,
                    isBirthdayCampaign: x.isBirthdayCampaign ,
                    monday: x.monday ,
                    name: x.name ,
                    promoType: x.promoType ,
                    promotedCategories: x.promotedCategories ,
                    promotedCategoriesDetail: x.promotedCategoriesDetail ,
                    promotedProducts: x.promotedProducts ,
                    promotedProductsDetail: x.promotedProductsDetail ,
                    promotedSuppliers: x.promotedSuppliers ,
                    promotedSuppliersDetail: x.promotedSuppliersDetail ,
                    rating: x.rating ,
                    saturday: x.saturday ,
                    startDate: x.startDate ,
                    sunday: x.sunday ,
                    thursday: x.thursday ,
                    tuesday: x.tuesday ,
                    validTo: x.validTo ,
                    value: x.value ,
                    wednesday: x.wednesday,
                    showDescription: !x.showDescription ,
                    contactValidFrom: x.contactValidFrom,
                    contactValidTo: x.contactValidTo
                };
            } else {
                return x;
            }
        });
        setPromo(temp_promo);
    }

    useEffect(() => {
        getPromo();
    }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


    // const getDay = (data: Promo) => {
    //     return {
    //         monday: data.monday,
    //         tuesday: data.tuesday,
    //         wednesday: data.wednesday,
    //         thursday: data.thursday,
    //         friday: data.friday,
    //         saturday: data.saturday,
    //         sunday: data.sunday
    //     }
    // }

    const getPromoDaysWithWrap = (data: Promo) => {
        const listDays = (({ monday, tuesday, wednesday, thursday, friday, saturday, sunday}) =>
            ({ monday, tuesday, wednesday, thursday, friday, saturday, sunday}))(data);

        return getPromoDays(listDays);
    }

    const itemTemplate = (data: Promo) => {

        return (
            <div
                className="col-12 bg-white mt-2 p-0 mb-4 custom-card promo-style-component">
                <div className="flex flex-column">
                    {
                        data.appPicture ?
                            <img
                                src={process.env.REACT_APP_STORAGE_URL
                                 + data.appPicture}
                                style={{ borderRadius: "8px 8px 0 0" , borderBottom: '1px solid #edecec'}}
                                alt={data.name}
                            />
                            : <div></div>
                    }

                    <div className="p-2 pt-0">
                        <div className="flex overflow-hidden">
                            <div className="flex-grow-1 flex align-items-start justify-content-start">
                                <h2 className="mt-2 mb-0">{data.name}</h2>
                            </div>
                            {/* <div className="flex-none flex align-items-start justify-content-end mt-2 mb-0">
                                <i className={data.rating ? 'pi pi-thumbs-up-fill bg-white text-primary border-0' : 'pi pi-thumbs-up bg-white text-primary border-0' } style={{fontSize: '1.5rem'}}></i>
                            </div> */}
                        </div>

                        {
                          data.appTemplate?.length > 0 // Se è presente il template lo visualizzo
                          ?
                          <div dangerouslySetInnerHTML={{ __html: data.appTemplate }}></div>
                          :
                          (
                            data.description?.length > 0  // altrimenti se c'è, visualizzo la descrizione
                            ?
                            <div className="block mt-2">{data.description}</div>
                            :
                            <></>  // altrimenti nulla (e verrà visualizzato solo la descrizione generata lato client)
                          )
                        }

                            { (getPromoTypeDescription(data) && (data.appTemplate || data.description)) ?
                            <div>
                                <div
                                    className="block"
                                    style={{ fontSize: "14px" }}>
                                    <div className="flex overflow-hidden mt-2">
                                        <div
                                            className="flex-none flex align-items-center justify-content-end p-1"
                                            style={{cursor:'pointer'}}
                                            onClick={() => handleShowDescription(data.id)}>
                                            <div
                                                className="flex p-1 box-promo-description"
 >
                                                <div className="font-bold px-2">
                                                    {!data.showDescription
                                                        ? "Scopri di più"
                                                        : "Mostra meno"}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {data.showDescription ? (
                                    <div className="flex justify-content-center mt-0 px-2">
                                        <div className="flex flex-wrap align-items-center justify-content-center bg-white" style={{ fontStyle: 'italic' }}
                                            dangerouslySetInnerHTML={{ __html: getPromoTypeDescription(data) }}>
                                        </div>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                            : <div className="block mt-2" dangerouslySetInnerHTML={{ __html: getPromoTypeDescription(data) }}></div>
                                }

                            <div className="flex-grow-1 flex align-items-start justify-content-start p-1">
                                <div >
                                    <div className="flex flex-row flex-wrap">
                                    <div className="flex align-items-end justify-content-start ">
                                        <div
                                        className="text-left font-bold from-to-promo"
                                        style={{ fontSize: "10px" }}
                                        >
                                        VALIDO DAL
                                        </div>
                                        <div className=" ml-2 text-left font-bold" style={{ color: "green" }}>
                                        {moment(data.contactValidFrom).format("DD/MM/YYYY")}
                                        </div>
                                        <div
                                        style={{ fontSize: "10px" }}
                                        className="ml-2 text-right font-bold from-to-promo"
                                        >
                                        AL
                                        </div>
                                        <div className="ml-2 text-left font-bold" style={{ color: "green" }}>
                                        {moment(data.contactValidTo).format("DD/MM/YYYY")}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div> 

                            {
                                getPromoDaysWithWrap(data)
                                ?
                                <div className="flex-grow-1 flex align-items-start justify-content-start p-1">
                                    <div style={{ color: "green" }}>
                                        <div className="flex flex-row flex-wrap">
                                            <div className="flex align-items-end justify-content-start valid-days">
                                                <div dangerouslySetInnerHTML={{ __html: getPromoDaysWithWrap(data) }}></div>
                                                {/* { getPromoDaysWithWrap(data) } */}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                :
                                <></>
                            }


                            <div className="flex overflow-hidden">
                                    <div className="flex-grow-1 flex align-items-center justify-content-start">
                                        <div className="flex-none flex align-items-center justify-content-end p-1">
                                            <div
                                                className="flex p-1 box-promo-value"

                                            ><div className="ml-2 text-left font-bold mr-2 mb-1">
                                                {getValorePromo(data.promoType, data.value)}</div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                    </div>
                </div>
            </div>
        );
    };


    return (
      <>
          <div className="mt-2 promo-style-component">
            <div className="flex justify-content-center">
              <h2 className="mb-0 mt-2">Promozioni</h2>
            </div>
            <DataScroller
              value={promo}
              itemTemplate={itemTemplate}
              rows={100}
              buffer={0.4}
              header=""
              emptyMessage={
                <div className="text-center text-lg mt-5">
                    {
                        errorGetPromo
                        ?
                        <div className="flex flex-column">

                            {
                                isOnline
                                ?
                                <></>
                                :
                                <div className='mb-3'>
                                <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                                </div>
                            
                            }

                            <div>Impossibile caricare le Promozioni.</div>
                            {
                                navigator.onLine
                                ?
                                <></>
                                :
                                <div>Verifica la connessione internet.</div>
                            }
                        </div>
                        :
                        <div className='nothing-find'>
                            Nessuna Promozione trovata
                        </div>
                    }
                  
                </div>
              }
            />
          </div>
      </>
    );
    
}
        